@use "ui/styles/fontStyles";
@use "ui/styles/sizes";
@use "ui/styles/colors";
@use "ui/styles/fonts";
@use "ui/styles/effects";

.wrapper {
  display: flex;
  flex-direction: column;
  gap: sizes.$s7;
  align-items: flex-start;
}

.summaryWrapper {
  // Set exact top spacing: modal bodyPadding (18px) + .modal-body margin-top (24px) = 42px total
  // We want 16px total, so: margin-top: -26px
  // Using !important since we control this component and need to override parent spacing
  margin-top: -26px !important;
}

.section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: sizes.$s4; 
  align-self: auto;
  color: colors.$gray60;
}

// Override ReadOnlyTreeSelect font size to 14px (body2-medium) instead of 12px (body3-medium)
// Using the className prop on ReadOnlyTreeSelect to scope the override
.locationTree {
  // Target classes that contain "label", "bullet", or "descriptor" in their scoped names
  span[class*="label"],
  span[class*="bullet"],
  span[class*="descriptor"] {
    @include fontStyles.body2-medium;
  }
}

.sectionTitle {
  @include fontStyles.body2-medium;
  color: colors.$gray60;
  margin: 0;
}

.details {
  @include fontStyles.body2-medium;

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: sizes.$s6;
}

.value {
  @include fontStyles.body2-medium;
  color: colors.$black;
}

.plansList {
  display: flex;
  width: 100%;
  max-width: 528px;
  flex-direction: column;
  align-items: flex-start;
  gap: sizes.$s3;
  padding: 0;
}

.planItem {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: sizes.$s6;
  align-self: auto;
  padding: 0;
}

.planName {
  @include fontStyles.body2-medium;
  color: colors.$black;
  font-feature-settings: 'liga' off, 'clig' off;
  width: 200px; 
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.planPrice {
  @include fontStyles.body2-medium;

  color: colors.$black;
  font-feature-settings: 'liga' off, 'clig' off;
  width: 88px; 
  text-align: right;
}

.duplicateWarning {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: sizes.$s3 sizes.$s5;
  background-color: colors.$yellowLightest;
  color: colors.$yellowDark;
  border-radius: effects.$borderRadiusM;
  @include fontStyles.body4-medium;
  width: sizes.$s12; 
  box-sizing: border-box;

  cursor: help;
  white-space: nowrap;
}

.successWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: sizes.$s5;
  padding: sizes.$s8 0;
}

.successName {
  @include fontStyles.h5-bold;
  color: colors.$gray90;
  text-align: center;
}

.successSubtitle {
  @include fontStyles.h6-book;
  color: colors.$gray90;
  text-align: center;
}

.successButton {
  width: 260px;
}


.duplicateTooltip {
  display: flex;
  flex-direction: column;
  gap: sizes.$s4;
  max-width: 360px;
}

.duplicateTooltipTitle {
  font-size: fonts.$small;
  font-weight: fonts.$medium;
  line-height: 120%;
  color: colors.$white;
}

.duplicateTooltipList {
  font-size: fonts.$small;
  font-weight: fonts.$book;
  line-height: 120%;
  color: colors.$white;
  white-space: pre-line;
}

.duplicateTooltipNote {
  font-size: fonts.$small;
  font-weight: fonts.$book;
  line-height: 120%;
  color: colors.$gray10;
}

.reportingUnitsTable {
  @include fontStyles.body2-medium;

  th {
    text-align: left;
    padding-right: sizes.$s6;
    @include fontStyles.body3-medium;
    color: colors.$gray60;
  }

  td {
    padding: sizes.$s2 sizes.$s6 sizes.$s2 0;
  }
}

.unitNameCell {
  color: colors.$black;
}

.unitIdCell {
  color: colors.$gray50;
  font-family: monospace;
}

.unitExternalIdCell {
  color: colors.$gray50;
}